import { UPDATE_USER_POSITION } from "constants/constants";
import { distanceEnKm } from '../components/utils/Position.js';
import axios from 'axios';
import { URL_API } from '../constants/settings';

const initialState = {
};

const UserPositionReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_USER_POSITION:
      console.log(`[GEO] Remontée de position`);
      const anciennePositionConnue = state && state.latitude && state.longitude;
      const nouvellePositionConnue = action.payload && action.payload.latitude && action.payload.longitude;
      if (nouvellePositionConnue) {
        axios({
          method: 'post',
          url: URL_API + '/utilisateurs/current/position',
          data: { latitude: action.payload.latitude, longitude: action.payload.longitude }
        });
      }
      if (anciennePositionConnue || nouvellePositionConnue) {
        const distance = distanceEnKm(state, action.payload);
        console.log(`[GEO] Position utilisateur = {Latitude: ${action.payload?.latitude}, Longitude: ${action.payload?.longitude}}`);
        console.log(`[GEO] Distance parcourue : ${distance}`);
        if (distance>0.01 || distance<0) {
          return action.payload
        }
      }
    default:
      return state;
  }
};

export default UserPositionReducer;